/* eslint-disable import/prefer-default-export */

export const FORM_RULES = {
  name: {
    presence: true,
  },
  email: {
    presence: true,
    email: true,
  },
  message: {
    presence: true,
  },
  phone: {
    presence: true,
    numericality: true,
    length: {
      minimum: 7,
      maximum: 14,
    },
  },
};
